<template>
  <base-modal
    :customShowDialog="customShowModal"
    :title="title"
    :confirmButton="confirmButtonText"
    :confirmEnabled="!(selectedElementId === null || selectedElementId === '')"
    @close="$emit('close')"
    @confirmed="$emit('confirmed', selectedElementId)"
  >
  <div slot="body" class="body-text">
    <slot name="subtitle" class="heading-3"></slot>
    <v-container
      v-for="element in listItems"
      class="element-container"
      :class="element.selected ? 'element-container-selected' : ''"
      v-bind:key="element.name"
      @click="handleElementClick(element.name)"
    >
      <v-layout row class="element-name-row-container">
        <v-flex xs1>
          <div class="element-toggle-btn" :class="isSourceExample ? 'element-toggle-btn-source' : ''">
            <div v-if="isSourceExample" class="element-toggle-btn-container">
              <img class="element-toggle-btn-icon" :src="element.imgUrl" :alt="`Logo icon of ${element.name}`">
            </div>
            <div v-if="isTemplate" class="element-toggle-btn-radio" :class="element.isSelected ? 'element-toggle-btn-radio-selected':''"></div>
          </div>
        </v-flex>
        <v-container column>
          <v-layout row class="element-heading-container">
            <span class="element-name-text" :class="isSourceExample ? 'element-name-text-source' : ''">
              {{ element.name }}
              <span v-if="isTemplateExample" class="element-name-divider"></span>
            </span>
            <span v-if="isTemplateExample" class="element-subtitle" v-html="buildTemplateTitle(element.subtitle)"></span>
<!--  @todo - Logic to add Tags when decided -->
<!--            <div v-if="isSourceExample">-->
<!--              <div-->
<!--                v-if="element.tags.length > 0"-->
<!--                v-for="tag in element.tags"-->
<!--                class="element-tag-container"-->
<!--                :key="tag"-->
<!--              >-->
<!--                <span class="element-tag">{{ tag }}</span>-->
<!--              </div>-->
<!--            </div>-->
          </v-layout>
          <v-layout column>
          <hr class="hr-element">
          <v-flex class="element-description-container">
            <span class="element-description">{{ element.useCase }}</span>
          </v-flex>
          </v-layout>
        </v-container>
      </v-layout>
    </v-container>
  </div>
  </base-modal>
</template>

<script>
export default {
  name: 'select-element-modal',
  props: ['customShowModal', 'isTemplateExample', 'isSourceExample', 'title', 'confirmButtonText', 'listItems'],
  components: {
    BaseModal: () => import('../modals/BaseModal')
  },
  data () {
    return {
      selectedElementId: null,
      isTemplate: this.isTemplateExample || false,
      isSource: this.isSourceExample || false
    }
  },
  methods: {
    buildTemplateTitle (title) {
      let individualWords = title.split(' ')
      let resultingComponent = []
      individualWords.map(word => {
        resultingComponent.push(`<span class="element-subtitle-first-letter">${word[0]}</span>${word.substring(1)}`)
      })
      return resultingComponent.join(' ')
    },
    handleElementClick (elementName) {
      this.listItems.forEach(element => {
        element.selected = element.name === elementName
      })
      this.selectedElementId = this.listItems.find(element => element.name === elementName).sampleUrl
    },
    handleImageError (event) {
      event.target.src = '../../../static/source-logo/database-icon.svg'
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  padding: 0;
}
.element {
  &-container {
    border-radius: 5px;
    margin-bottom: 15px;
    border: 1px solid #DBE0E6; // grey-500
    box-shadow: 2px 2px #33344835;
    cursor: pointer;
    &:hover {
      border-color: #3592EB; // blue-primary
      box-shadow: 2px 2px #3592EB; // blue-primary
      & .element-toggle-btn {
        background-color: #3592EB; // blue-primary
      }
      & .element-toggle-btn-radio {
        background-color: #E1F5FE; // blue-400
      }
    }
    &-selected {
      border-color: #FF9800; // warning-500
      box-shadow: 2px 2px #FF9800; // warning-500
      & .element-toggle-btn-radio {
        border-width: 5px;
        transition: 200ms;
      }
      & .element-toggle-btn {
        background-color: #FF9800; // warning-500
      }
      &:hover {
        border-color: #FF9800; // warning-500
        box-shadow: 2px 2px #FF9800; // warning-500
        & .element-toggle-btn {
          background-color: #FF9800; // warning-500
        }
      }
    }
  }
  &-container-source:hover {
    box-shadow: 0 2px 2px 2px #E1F5FE; // light-blue-400
  }
  &-heading-container {
    padding-left: 5px;
  }
  &-toggle-btn {
    height: 100%;
    background-color: #DBE0E6; // grey-500
    border-radius: 3px 0 0 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    &-container {
      aspect-ratio: 1;
      background-color: white;
      border-radius: 50%;
      padding: 4px;
      height: 32px;
    }
    &-icon {
      height: 24px;
      aspect-ratio: 1;
    }
    &-radio {
      height: 25px;
      aspect-ratio: 1;
      border-radius: 50%;
      background-color: #F9FCFF; // bg-primary
      border: 1px solid #9093A4; // grey-600
      &-selected {
        background-color: #E1F5FE; // light-blue-400
      }
    }
  }
  &-name {
    &-text {
      font-weight: bold;
      min-width: 82px;
      position: relative;
      padding-right: 20px;
      padding-left: 10px;
      &-source {
        font-weight: unset;
        min-width: 166px;
      }
    }
    &-divider {
      position: absolute;
      right: 10px;
      top: 17.5%;
      height: 65%;
      width: 2px;
      background-color: #30414F; // black-700
      border-radius: 2px;
    }
  }
  &-tag {
    background-color: #DBE0E6; // grey-500
    border-radius: 10px;
    padding: 0 10px;
  }
  &-description {
    color: #9093A4; // grey-800
    font-size: 12px;
    &-container {
      margin: 5px 0;
      padding-left: 25px;
    }
  }
}
.hr-element {
  border-width: .5px;
  border-style: solid;
  border-color: #DBE0E6; // grey-500
}
</style>



// WEBPACK FOOTER //
// src/components/modals/SelectElementModal.vue